// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list {
    height:230px;
    overflow:auto;
}
.badge {
    margin-left: auto;
    width: 20px;
    height: 20px;
    text-align: center;
    background-color: red;
    border-radius: 10px;
    color: white;
}
.eventName {
    width: auto;
}

.layoutTree {
    height: 100%;
    min-width: 250px;
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/menutabs/pagesettings/pagesettings.menu.tab.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".list {\n    height:230px;\n    overflow:auto;\n}\n.badge {\n    margin-left: auto;\n    width: 20px;\n    height: 20px;\n    text-align: center;\n    background-color: red;\n    border-radius: 10px;\n    color: white;\n}\n.eventName {\n    width: auto;\n}\n\n.layoutTree {\n    height: 100%;\n    min-width: 250px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
